import React, { useState } from 'react'
import { LooksTwo } from '@mui/icons-material'
import InfoIcon from '@mui/icons-material/Info'
import {
  Box,
  Stack,
  Tooltip,
  Typography
} from '@mui/material'
import Flipcard from 'common/Card/Flipcard'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import AddUserPlanDialog from 'pages/Customers/sharedDialogs/AddUserPlanDialogICCID'
import {
  EsimInfoStatus,
  EsimsInfoPaginated
} from 'types/api/faber/dataUsage.type'

import UserEsimsStatusLogsDialog from '../dialogs/UserEsimsDialog'

export interface EsimStatusCardPropsV2 {
  userId: string
  esimStatus?: EsimInfoStatus
  esimsInfo?: EsimsInfoPaginated
  pageNumber: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  pageCount: number
}

export default function EsimStatusCardV3({
  userId,
  esimStatus,
  esimsInfo,
  pageNumber,
  setPage,
  pageCount
}: EsimStatusCardPropsV2) {
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [isUserPlanDialogOpen, setUserPlanDialogOpen] = useState(false)
  const [selectedIccid, setSelectedIccid] = useState<string>('')

  const getEsimTooltipMessage = (status: string) => {
    if (status === 'no eSIMs enabled') {
      return 'No eSIM has been enabled.'
    }
    return 'The eSIM has been downloaded into a device and is active'
  }

  const handleAddUserPlan = (iccid: string) => {
    setSelectedIccid(iccid)
    setUserPlanDialogOpen(true)
  }

  return (
    <>
      <Flipcard
        warning={esimStatus?.statusMessage === 'no eSIMs enabled'}
        icon={<LooksTwo sx={{ fontSize: '40px', color: 'white' }} />}
        backContent={
          <NormalText mt='2rem'>
            Please get customer to install eSim and turn on data roaming
          </NormalText>
        }
      >
        <NormalText
          isBold
          textAlign={'left'}
          sx={{ fontSize: '24px', fontWeight: '700px', m: 0 }}
          text={'eSim Status'}
        />
        <TextColorFontBody
          sx={{
            fontSize: '14px',
            lineHeight: 1,
            color: '#7B8794',
            textAlign: 'left',
            mt: 1
          }}
        >
          The current state of the customer&apos;s eSim. Please ensure
          customer&apos;s eSIM is enabled if they&apos;re travelling
        </TextColorFontBody>
        <Stack sx={{ mt: 1 }}>
          <Typography
            sx={{ fontWeight: '400', color: '#7B8794' }}
            textAlign='left'
          >
            Status
          </Typography>
          <Stack flexDirection={'row'} spacing={1}>
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: '28px',
                pt: '2px',
                color: esimStatus?.statusColor
              }}
            >
              {esimStatus?.statusMessage}
            </Typography>

            {esimStatus?.statusMessage ? (
              <Tooltip
                PopperProps={{
                  sx: { maxWidth: '165px', textAlign: 'center' }
                }}
                title={getEsimTooltipMessage(esimStatus?.statusMessage)}
              >
                <InfoIcon fontSize='small' color='disabled' />
              </Tooltip>
            ) : null}
          </Stack>
          {esimStatus?.statusMessage === 'ENABLED' && (
            <Typography
              sx={{ fontWeight: '400', color: '#7B8794' }}
              textAlign='left'
            >
              {esimStatus?.enabledEsimICCID}
            </Typography>
          )}
          <Box onClick={() => setDialogOpen(true)} sx={{ m: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                fontSize: '14px',
                fontWeight: '500',
                color: 'blue',
                textDecoration: 'underline'
              }}
              textAlign='left'
            >
              {'Show all eSIM'}
            </Typography>
          </Box>
        </Stack>
      </Flipcard>

      <UserEsimsStatusLogsDialog
        userId={userId}
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        esimsInfo={esimsInfo}
        pageNumber={pageNumber}
        setPage={setPage}
        pageCount={pageCount}
        onAddUserPlan={handleAddUserPlan}
      />

      {/* add user plan dialog */}
      <AddUserPlanDialog
        userPlanDialogOpen={isUserPlanDialogOpen}
        userId={userId}
        iccid={selectedIccid}
        handleUserPlanDialogClose={() => setUserPlanDialogOpen(false)}
      />
    </>
  )
}
